module.exports = __webpack_public_path__ + "img/centrum.1f792804.png";